import { faArrowToBottom } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Spinner } from '@kcftech/design-system';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

// `!important` necessary because of dsm <-> styled-components weirdness
export const ExportButtonSpinner = styled(Spinner)`
    color: ${tokens.text.onColor} !important;
`;

export type ExportReportButtonProps = Readonly<{
    exporting: boolean;
    disabled: boolean;
    onDownloadClick: () => void;
}>;

export function ExportReportButton({
    exporting,
    disabled,
    onDownloadClick,
}: ExportReportButtonProps) {
    return (
        <Button
            disabled={disabled || exporting}
            onClick={onDownloadClick}
            icon={
                exporting ? (
                    <ExportButtonSpinner className="inline-block" size="1x" />
                ) : (
                    <FontAwesomeIcon icon={faArrowToBottom} />
                )
            }
        >
            Export Report
        </Button>
    );
}
